import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
// Components
import Header from '../components/Header/header';
import PageBanner from '../components/Banner/page-banner';
import AboutCard from '../components/About/about-card';

// Dependencies

// Images
import misionSvg from './../svg/mision.svg';
import visionSvg from './../svg/eye.svg';
import matrizSvg from './../svg/matriz.svg';
import sucursalSvg from './../svg/sucursal.svg';
import valuesSvg from './../svg/valores.svg';
import Value from '../components/About/value';
import ModalPortal from '../portals/ModalPortal';
import MapModal from '../components/About/mapModal';
import {
   CANCUN_MAP_URL,
   CANCUN_MAP_URL2,
   PLAYA_DEL_CARMEN_MAP_URL,
} from '../redux/constants';
import { VALUES } from '../utils/consts';

class Nosotros extends Component {
   constructor(props) {
      super(props);
      this.state = { showModal: false, mapUrl: '' };
   }

   componentDidMount() {
      document.addEventListener('keydown', this.handleKeyDown);
      const { hash } = window.location;
      if (hash) {
         const element = document.getElementById(hash.substring(1));
         if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
         }
      }
   }

   componentWillUnmount() {
      document.removeEventListener('keydown', this.handleKeyDown);
   }

   handleShowModal(mapUrl) {
      console.log(mapUrl);
      this.setState({ mapUrl: mapUrl, showModal: !this.state.showModal });
   }

   handleKeyDown = event => {
      if (event.key === 'Escape' && this.state.showModal) {
         this.handleShowModal();
      }
   };

   render() {
      return (
         <React.Fragment>
            <div className="flex main-nosotros ">
               <Helmet>
                  <title>NOSOTROS - Expo Médica </title>
               </Helmet>
               <div className="column">
                  <Header inicio={true}></Header>
                  <div className="nosotros">
                     <div className="column">
                        <PageBanner title="Nosotros" />
                        <div className="white-space-64"></div>
                        <div className="about-us align-center">
                           <div className="container about-card-container">
                              <AboutCard title="Misión" icon={misionSvg}>
                                 <p className="color-white">
                                    Nos convertiremos en la exposición médica y
                                    ortopédica de referencia en cuanto a
                                    productos novedosos en el ramo médico, y a
                                    través del continuo aprendizaje,
                                    fortaleceremos el bienestar vinculándolo con
                                    el concepto de farmacia ortopédica.
                                 </p>
                              </AboutCard>
                              <AboutCard title="Visión" icon={visionSvg}>
                                 <p className="color-white">
                                    Somos una empresa dedicada a la
                                    comercialización de una amplia gama de
                                    artículos médicos y ortopédicos. Estamos
                                    altamente calificados para proporcionar
                                    soluciones con productos que mejoren la
                                    movilidad y calidad de vida de nuestros
                                    clientes.
                                 </p>
                              </AboutCard>
                           </div>
                           <div className="white-space-32"></div>
                           <div className="container about-values-container">
                              <div className="about-values">
                                 <img src={valuesSvg} width={50} />
                                 <h2 className="quicksand color-secondary about-card-title">
                                    Valores
                                 </h2>
                                 <div className="values column">
                                    {VALUES.reduce((acc, curr, index) => {
                                       if (index % 4 === 0) {
                                          acc.push([]);
                                       }
                                       acc[acc.length - 1].push(
                                          <Value
                                             key={index}
                                             icon={curr.icon}
                                             content={curr.content}
                                          />
                                       );
                                       return acc;
                                    }, []).map((group, groupIndex) => (
                                       <div
                                          key={groupIndex}
                                          className="value-group"
                                       >
                                          {group}
                                       </div>
                                    ))}
                                 </div>
                              </div>
                           </div>
                           <div className="white-space-32"></div>

                           <div className="container about-card-container">
                              <AboutCard
                                 title="Sucursal Cobá"
                                 icon={matrizSvg}
                                 theme="soft-red"
                                 className="matriz"
                              >
                                 <div>
                                    <h4 className="color-secondary quicksand about-city-txt">
                                       Cancún
                                    </h4>
                                    <i
                                       className="fas fa-map-marker-alt about-city-icon"
                                       onClick={() =>
                                          this.handleShowModal(CANCUN_MAP_URL2)
                                       }
                                    />
                                 </div>

                                 <div className="white-space-8" />
                                 <p className="about-direction-txt">
                                    Av. Coba Lt 25-1 MZ.13 SM.22 Loc. 102 y 203
                                    Cancún, Q. Roo 77500
                                 </p>
                                 <p className="about-direction-txt">
                                    TEL: 998-887-9509 y 998-310-3312
                                 </p>
                                 <p
                                    className="about-direction-txt"
                                    id="cancun-location"
                                 >
                                    <i className="fab fa-whatsapp" />
                                    998-3509562
                                 </p>
                              </AboutCard>
                              <AboutCard
                                 title="Sucursal Playa del Carmen"
                                 icon={sucursalSvg}
                                 theme="soft-red"
                              >
                                 <div>
                                    <h4 className="color-secondary quicksand about-city-txt">
                                       Playa del Carmén
                                    </h4>
                                    <i
                                       className="fas fa-map-marker-alt about-city-icon"
                                       onClick={() =>
                                          this.handleShowModal(
                                             PLAYA_DEL_CARMEN_MAP_URL
                                          )
                                       }
                                    />
                                 </div>

                                 <div className="white-space-8" />
                                 <p className="about-direction-txt">
                                    45 Av. Plaza Chedraui centro LOC. 23 y 25 E
                                    Carretera Cancún - Tulum Col. Centro 77710
                                 </p>
                                 <p
                                    className="about-direction-txt"
                                    id="cancun-location"
                                 >
                                    <i className="fab fa-whatsapp" />
                                    984-222-3739
                                 </p>
                              </AboutCard>
                           </div>
                           <div className="white-space-32"></div>
                           <div className="container about-card-container">
                              <AboutCard
                                 title="Sucursal Crucero"
                                 icon={sucursalSvg}
                                 theme="soft-red"
                              >
                                 <div>
                                    <h4 className="color-secondary quicksand about-city-txt">
                                       Cancún
                                    </h4>
                                    <i
                                       className="fas fa-map-marker-alt about-city-icon"
                                       onClick={() =>
                                          this.handleShowModal(CANCUN_MAP_URL)
                                       }
                                    />
                                 </div>

                                 <div className="white-space-8" />
                                 <p className="about-direction-txt">
                                    Calle 3, MZ. 9 SM.65 Cancun, Loc. 1 y 2.
                                    Cancun Q. ROO 77524
                                 </p>
                                 <p className="about-direction-txt">
                                    TEL: 998-252-7580 y 998-884-1754
                                 </p>
                                 <p className="about-direction-txt">
                                    <i className="fab fa-whatsapp" />
                                    998-195-3527
                                 </p>
                              </AboutCard>
                           </div>
                        </div>

                        <div className="white-space-64"></div>
                     </div>
                  </div>
               </div>
            </div>
            {this.state.showModal && (
               <ModalPortal>
                  <MapModal
                     onClose={this.handleShowModal.bind(this)}
                     mapUrl={this.state.mapUrl}
                  />
               </ModalPortal>
            )}
         </React.Fragment>
      );
   }
}

export default Nosotros;



// WEBPACK FOOTER //
// ./src/pages/nosotros.js